var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"mobile-input",staticStyle:{"font-family":"Arial, FontAwesome"},attrs:{"placeholder":_vm.placeholder,"autocomplete":"rut2jfkde","type":"text"},domProps:{"value":_vm.content},on:{"input":_vm.reportInput,"keyup":_vm.report}})
}
var staticRenderFns = []

export { render, staticRenderFns }